import React, { useState, useEffect } from 'react';

const CustomSelectIcon = ({ options, defaultSelected, onSelect ,ontextchange , onpopclose }) => {
    const [selectedOption, setSelectedOption] = useState('');
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        setSelectedOption(defaultSelected);
    }, [defaultSelected]);

    const [shouldCloseDropdown, setShouldCloseDropdown] = useState(false);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionSelect = (option) => {
        setSelectedOption(option);
        // setShouldCloseDropdown(true);
        onSelect(option);
    };

    const handleUpdateStatus = () => {
        // Handle the update status logic here
        setShouldCloseDropdown(true);
        onpopclose(true);
    };

    useEffect(() => {
        if (shouldCloseDropdown) {
            setIsOpen(false);
            setShouldCloseDropdown(false);
        }
    }, [shouldCloseDropdown]);

    return (
        <div className={`custom-select w-100 ${isOpen ? 'open' : ''}`}>
            <div className="selected-option-drop" onClick={toggleDropdown}>
                <span className="selected-option-img">
                    {selectedOption.icon}
                </span>
                <span className="selected-option-text">{selectedOption.label}</span>
                <span className={`icon ${isOpen ? 'up' : 'down'}`}>
                    <i className="bi bi-chevron-down" />
                </span>
            </div>
            {isOpen && (
                <div className="options-list custom-options-list club-status">
                    <div className='drop-down-list'>
                        {options.map(option => (
                            <div
                                key={option.value}
                                className={`option custom-option ${selectedOption.value === option.value ? 'selected' : ''}`}
                                onClick={() => handleOptionSelect(option)}
                            >
                                <span className="option-img">
                                    {option.icon}
                                </span>
                                <span className="option-label">{option.label}</span>
                            </div>
                        ))}
                    </div>
                    <div className="form-box-section">
                        <textarea className="dashboard-text-area" id="exampleFormControlTextarea1" onChange={(e) => { ontextchange(e.target.value) }} rows="8" placeholder="Leave your note here..." ></textarea>
                    </div>
                    <div className='form-box-section'>
                        <button className="btn btn_default bg-white text-dark btn_disabled" onClick={() => { handleUpdateStatus(); toggleDropdown(); }}>Update Status</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CustomSelectIcon;
